import Request from '../utilis/request';
import config from  '../config';
export function getIntegrations(params) {
    return Request({
        url:config.config.base_url+'/api/integrations'
    })
}

export function editAddIntegration(data, id = null) {
    var slug = (id)? '/'+id : '';
    return Request({
        url:config.config.base_url+'/api/integrations'+slug,
        method: (id)? 'put' : 'post',
        data: data
    })
}


export function deleteIntegration(id, type) {
    return Request({
        url:config.config.base_url+'/api/integrations/'+id,
        method: 'delete',
        data: {type}
    })
}

export function setProductIntegration(data) {
    return Request({
        url: config.config.base_url+'/api/integrations/products',
        method:'post',
        data:data
    })
}
